import { createStyles, Theme } from '@material-ui/core';

export default (theme: Theme) => createStyles({
  progressWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  progress: {
    color: theme.palette.primary.main,
  },
  smartLockContainer: {
    marginTop: theme.spacing(3),
    height: '800px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  iframe: {
    border: 'none',
    flexGrow: 1,
    height: '100%',
    width: '100%',
  },
});
